if (!customElements.get('dbtfy-shipping-checkpoints')) {
  customElements.define(
    'dbtfy-shipping-checkpoints',
    class DbtfyShippingCheckpoints extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.render();
      }

      formatDate(baseDate, offset = 0) {
        const date = new Date(baseDate);
        date.setDate(date.getDate() + offset);
        return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
      }

      render() {
        this.blockList = document.querySelectorAll('.dbtfy-shipping-checkpoint-block');
        if (!this.blockList.length) return;

        const today = new Date();

        const currentDateEl = this.querySelector('.current-date');
        if (currentDateEl) {
          currentDateEl.textContent = this.formatDate(today, 0);
        }

        const orderReadyOffset = parseInt(this.dataset.orderReadyDate, 10) || 0;
        const deliveryOffset = parseInt(this.dataset.deliveryDate, 10) || 0;

        const orderReadyDateEl = this.querySelector('.order-ready-date');
        if (orderReadyDateEl) {
          orderReadyDateEl.textContent = this.formatDate(today, orderReadyOffset);
        }

        const deliveryDateEl = this.querySelector('.delivery-date');
        if (deliveryDateEl) {
          deliveryDateEl.textContent = this.formatDate(today, deliveryOffset);
        }

        this.blockList.forEach((block) => {
          block.innerHTML = this.innerHTML;
        });

        this.remove();
      }
    }
  );
}
